export default function getDefaultState () {
  return {
    requests: [],
    serviceUnavailableError: false,
    showPendingRequestWarning: false
  }
}
